/**
 * Centralized Map Color Configuration
 * Shared colors for all SimpleMaps (US, Canada, World) and rep-finder.js
 */

var MAP_COLORS = {
  // Brand colors
  brandBlue: '#0F3D80',        // Primary brand blue
  white: '#FFFFFF',

  // Map background
  background: '#F5F2E9',       // Stone off-white background

  // Default state/country colors
  stoneDefault: '#F5F2E9',     // Stone - default state/country color
  goldHover: '#0F3D80',        // Blue - hover state (matches selected)

  // Borders and labels
  border: '#0F3D80',           // Blue borders
  label: '#0F3D80',            // Blue text
  labelHover: '#FFFFFF',       // White text on hover

  // Special colors for world map
  northAmerica: '#7BA3C9',     // Lighter blue - US/Canada on world map
  repCountry: '#B8860B',       // Gold - countries with reps on world map

  // Selected region (controlled by rep-finder.js)
  selected: '#0F3D80'          // Blue - selected state/country
};
